// Vendor Libraries
import { ElementRef } from '@angular/core';
// Utils / Constants
import { formatDateString } from 'Core/redesign/utils/date';
import { isPeriodicityDisabled } from 'SecuritiesApp/ts/features/attribution-relative/utils';
import { AS_OF_DATE_DAILY, AS_OF_DATE_CUSTOM, AS_OF_DATE_DROPDOWN_CONFIG, HOLDINGS_LAYER_DROPDOWN_CONFIG, DIRECT_HOLDINGS, INTERMEDIARY_HOLDINGS, } from 'SecuritiesApp/ts/constants/attribution.constants';
// Interfaces
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { ContributionMetric } from '../../../enums/attribution.enums';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i3 from "../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/components/date-controls/single-date-picker/single-date-picker.component";
import * as i5 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i6 from "./attribution-absolute-chart/attribution-absolute-chart.component";
import * as i7 from "./attribution-absolute-table/attribution-absolute-table.component";
const _c0 = () => ({ button: "btn btn-secondary dropdown-toggle width-180 d-flex justify-content-between", dropdownContainer: "dropdown mt-1" });
export class AttributionAbsoluteComponent {
    constructor(eltRef, accountsService) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.performancePeriodicity = PerformancePeriodicity.ONE_YEAR;
        this.metric = ContributionMetric.DOLLARS;
        this.asOfDateConfig = AS_OF_DATE_DROPDOWN_CONFIG;
        this.holdingsLayerConfig = HOLDINGS_LAYER_DROPDOWN_CONFIG;
        this.CUSTOM_OPTION = AS_OF_DATE_CUSTOM;
        this.asOfDate = AS_OF_DATE_DAILY;
        this.holdingsLayer = DIRECT_HOLDINGS;
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityType = this.eltRef.nativeElement.getAttribute('securityType');
        this.performancePeriodicity = this.eltRef.nativeElement.getAttribute('performancePeriodicity');
        this.metric = this.eltRef.nativeElement.getAttribute('metric');
        this.holdingsLayer = this.eltRef.nativeElement.getAttribute('holdingsLayer');
        this.asOfDate = this.eltRef.nativeElement.getAttribute('asOfDate');
        const selectedAsOfDateCustom = this.eltRef.nativeElement.getAttribute('customDate');
        if (selectedAsOfDateCustom && this.asOfDate === AS_OF_DATE_CUSTOM) {
            this.asOfDateCustom = new Date(selectedAsOfDateCustom);
        }
        const hasNestedModelPortfolios = JSON.parse(this.eltRef.nativeElement.getAttribute('hasNestedModelPortfolios'));
        if (hasNestedModelPortfolios) {
            this.holdingsLayerConfig.list.splice(1, 0, {
                label: 'Invested Holdings',
                type: 'option',
                value: INTERMEDIARY_HOLDINGS,
            });
        }
        else if (this.holdingsLayer === INTERMEDIARY_HOLDINGS) {
            this.holdingsLayer = DIRECT_HOLDINGS;
        }
    }
    holdingsHandler(holdings) {
        if (holdings !== this.holdingsLayer) {
            const preferenceName = `${this.securityType}_attribution_absolute_tab_holdings_layer`;
            this.accountsService.putUserPreferences({ [preferenceName]: holdings }).subscribe(() => {
                window.location.reload();
            });
        }
    }
    asOfDateHandler(asOfDate) {
        if (asOfDate !== this.asOfDate) {
            this.asOfDate = asOfDate;
            if (asOfDate === AS_OF_DATE_CUSTOM) {
                return;
            }
            let putParams;
            if (isPeriodicityDisabled(this.performancePeriodicity, asOfDate)) {
                this.performancePeriodicity = PerformancePeriodicity.THREE_MONTHS;
                putParams = {
                    [`${this.securityType}_attribution_absolute_tab_zoom`]: this.performancePeriodicity,
                    [`${this.securityType}_attribution_absolute_tab_as_of_date`]: asOfDate,
                };
            }
            else {
                putParams = {
                    [`${this.securityType}_attribution_absolute_tab_as_of_date`]: asOfDate,
                    [`${this.securityType}_attribution_absolute_tab_date`]: null,
                };
            }
            this.accountsService.putUserPreferences(putParams).subscribe(() => {
                window.location.reload();
            });
        }
    }
    dateChangeHandler(date) {
        const dateString = date ? formatDateString(date) : '';
        const datePreferenceName = `${this.securityType}_attribution_absolute_tab_date`;
        const asOfDatePreferenceName = `${this.securityType}_attribution_absolute_tab_as_of_date`;
        this.accountsService
            .putUserPreferences({ [datePreferenceName]: dateString, [asOfDatePreferenceName]: AS_OF_DATE_CUSTOM })
            .subscribe(() => {
            window.location.reload();
        });
    }
}
AttributionAbsoluteComponent.ɵfac = function AttributionAbsoluteComponent_Factory(t) { return new (t || AttributionAbsoluteComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService)); };
AttributionAbsoluteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionAbsoluteComponent, selectors: [["ycn-attribution-absolute"]], decls: 22, vars: 27, consts: [["helpModal", ""], [1, "row", "align-items-end"], [1, "col-auto", "col-md-8", "mb-2"], [1, "row"], [1, "col-auto"], [1, "label", "form-label", "form-label-thin"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "col", "col-md-4", "mb-2", "d-flex", "justify-content-end", "align-items-end"], ["ycnTooltip", "", 1, "help-toggler", 3, "click", "tooltipHtml", "tooltipPlacement", "tooltipTitle"], [1, "col-auto", "align-self-end"], [1, "form-group", "dropdown", "menu-right", 3, "dateChangeHandler", "selectedDate", "inputDisabled", "datePlaceholder"], [3, "performancePeriodicityChange", "securityId", "securityType", "performancePeriodicity", "asOfDateCustom", "asOfDate", "holdingsLayer"], [3, "securityId", "securityName", "securityType", "metric", "asOfDateCustom", "asOfDate", "holdingsLayer"]], template: function AttributionAbsoluteComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "div", 5);
        i0.ɵɵtext(5, "Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ycn-single-select-dropdown", 6);
        i0.ɵɵlistener("changeHandler", function AttributionAbsoluteComponent_Template_ycn_single_select_dropdown_changeHandler_6_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.holdingsHandler($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(7, "div", 7)(8, "div", 3)(9, "div", 4)(10, "div", 5);
        i0.ɵɵtext(11, "As of\u00A0");
        i0.ɵɵelementStart(12, "span", 8);
        i0.ɵɵlistener("click", function AttributionAbsoluteComponent_Template_span_click_12_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(21); return i0.ɵɵresetView(helpModal_r2.openModal("mp_creator_as_of_date")); });
        i0.ɵɵtext(13, "(?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "ycn-single-select-dropdown", 6);
        i0.ɵɵlistener("changeHandler", function AttributionAbsoluteComponent_Template_ycn_single_select_dropdown_changeHandler_14_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.asOfDateHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "div", 9)(16, "ycn-single-date-picker", 10);
        i0.ɵɵlistener("dateChangeHandler", function AttributionAbsoluteComponent_Template_ycn_single_date_picker_dateChangeHandler_16_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateChangeHandler($event)); });
        i0.ɵɵtext(17, "> ");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(18, "ycn-attribution-absolute-chart", 11);
        i0.ɵɵtwoWayListener("performancePeriodicityChange", function AttributionAbsoluteComponent_Template_ycn_attribution_absolute_chart_performancePeriodicityChange_18_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.performancePeriodicity, $event) || (ctx.performancePeriodicity = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "ycn-attribution-absolute-table", 12)(20, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(25, _c0))("config", ctx.holdingsLayerConfig)("selectedValue", ctx.holdingsLayer);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", "Help");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(26, _c0))("config", ctx.asOfDateConfig)("selectedValue", ctx.asOfDate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedDate", ctx.asOfDateCustom)("inputDisabled", ctx.asOfDate !== ctx.CUSTOM_OPTION)("datePlaceholder", "MM/DD/YYYY");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("securityId", ctx.securityId)("securityType", ctx.securityType);
        i0.ɵɵtwoWayProperty("performancePeriodicity", ctx.performancePeriodicity);
        i0.ɵɵproperty("asOfDateCustom", ctx.asOfDateCustom)("asOfDate", ctx.asOfDate)("holdingsLayer", ctx.holdingsLayer);
        i0.ɵɵadvance();
        i0.ɵɵproperty("securityId", ctx.securityId)("securityName", ctx.securityName)("securityType", ctx.securityType)("metric", ctx.metric)("asOfDateCustom", ctx.asOfDateCustom)("asOfDate", ctx.asOfDate)("holdingsLayer", ctx.holdingsLayer);
    } }, dependencies: [i2.HelpModalComponent, i3.SingleSelectDropdownComponent, i4.SingleDatePickerComponent, i5.TooltipDirective, i6.AttributionAbsoluteChartComponent, i7.AttributionAbsoluteTableComponent], encapsulation: 2 });
